module.exports = __webpack_public_path__ + "static/img/DSC_0092_01.46463cf2.png";